import React, { PureComponent } from "react";
import { Rect, Group, Circle } from "react-konva";
import Chamber from "./chamber";
import { connect } from "react-redux";
import { selectRow, deselectRow } from "../../actions/chamber-row-actions";
import { GLOBAL_DRAWING_SELECTOR_MODE_DIRECT } from "../../lib/types";

class ChamberRow extends PureComponent {
  handleOnHandlerClick() {
    if (this.props.isSelected) {
      this.props.deselectRow();
    } else {
      this.props.selectRow(this.props.row);
    }
  }

  handleOnHandlerMouseEnter() {
    this.handlerNode.getStage().container().style.cursor = "pointer";
  }

  handleOnHandlerMouseLeave() {
    this.handlerNode.getStage().container().style.cursor = "default";
  }

  renderChambers() {
    // this row reference
    let self = this;
    // the chambers
    let chambers = this.props.chambers;
    /* build and return rendered components */
    return chambers.map((chamber, i) => {
      /* render and return chambers */
      return (
        <Chamber
          x={chamber.x}
          y={chamber.y}
          col={chamber.col}
          row={chamber.row}
          rowRef={self}
          width={chamber.width}
          height={chamber.height}
          active={chamber.active}
          accessory={chamber.accessory}
          key={`${chamber.row}-${chamber.col}`}
          /* endcap properties */
          upperCapActive={chamber.upperCapActive}
          lowerCapActive={chamber.lowerCapActive}
          endCapWidth={self.props.endCapWidth}
          endCapHeight={self.props.endCapHeight}
          upperCapAccessory={chamber.upperCapAccessory}
          lowerCapAccessory={chamber.lowerCapAccessory}
          endCapInstalledOffset={self.props.endcapInstalledOffset}
          chamberInstalledOffset={self.props.chamberInstalledOffset}
          isVoidArray={chamber._isVoidArray}
          isManifoldConnectedArray={chamber._isManifoldConnectedArray}
          isOppositeStubAttached={chamber._isOppositeStubAttached}
        />
      );
    });
  }

  /**
   * Not in use
   * @returns {{top: null, lower: null}}
   */
  getEndCapsPosition() {
    /*/!* the row chambers array *!/
    let chambers = this.props.chambers;
    let top = null;
    let lower = null;

    /!* find top active chamber *!/
    for (let i = 0; i < chambers.length; i++) {
      let c = chambers[i];
      /!* if chamber is active *!/
      if (c.active) {
        /!* if top active chamber has not been set, set the top position for endcap *!/
        if (top === null) {
          top = c.x - this.props.endCapWidth;
        }
        /!* set the lower as the last found active chamber *!/
        lower = c.x + c.width + this.props.endCapWidth;
      }
    }
    return {
      top,
      lower,
    };*/
  }

  render() {
    let rowSelectionOffset = this.props.width + this.props.endCapWidth * 1.5;
    if (this.props.rowSelectionOffset !== 0) {
      rowSelectionOffset = this.props.rowSelectionOffset - this.props.x;
    }

    /* render the row */
    return (
      <Group
        name="chamberRow"
        x={this.props.x}
        y={this.props.y}
        id={this.props.row}
        width={this.props.width}
        height={this.props.height}
      >
        <Rect
          dash={[3, 3]}
          width={this.props.width}
          height={this.props.height}
          strokeWidth={this.props.isSelected ? 5 : 1}
          ref={(node) => {
            this.rowBorderNode = node;
          }}
          stroke={this.props.isSelected ? "#0078D4" : "transparent"}
        />
        {/* rendering the chambers */}
        {this.renderChambers()}
        <Circle
          stroke="black"
          strokeWidth={1}
          x={rowSelectionOffset}
          y={this.props.height / 2}
          radius={this.props.endCapHeight / 2.5}
          ref={(node) => {
            this.handlerNode = node;
          }}
          onClick={() => this.handleOnHandlerClick()}
          fill={"orange"}
          onMouseEnter={() => this.handleOnHandlerMouseEnter()}
          onMouseLeave={() => this.handleOnHandlerMouseLeave()}
          visible={
            this.props.drawingSelectorMode ===
            GLOBAL_DRAWING_SELECTOR_MODE_DIRECT
          }
        />
      </Group>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    /* the global pressed keys set */
    drawingSelectorMode: state.globals.drawingSelectorMode,
    pressedKeys: state.globals.pressedKeys,
  };
};

const mapDispatchToProps = {
  selectRow,
  deselectRow,
};

/* export this contained component */
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChamberRow);



// WEBPACK FOOTER //
// ./src/components/Drawings/chamber-row.js